/**
 * In SSR we need to concat the crehana url plus the graphql endpoint so the apollo client will use the crehana api instead of the nextjs node server.
 * Ex, giving the endpoint "/api/v2/graph/" it will result in:
 *  Server => "https://www.crehana.com/api/v2/graph/"
 *  Client => "/api/v2/graph/"
 * It's not necessary in the client because the nextjs app will live inside the crehana domain
 * IMPORTANT: To make it work un dev-local we have to configure nextjs rewrites /api/** => qa.creha.co/api/** (check the config.js in the root)
 */
var concatUrl = function concatUrl(endpoint) {
  if (typeof window === 'undefined' || process.env.API_FULL_PATH) {
    var apiUrl = process.env.API_URL || '';
    return "".concat(apiUrl).concat(endpoint);
  }
  return endpoint;
};
var BASE_PATH = '/api/v2/graph';
export var GRAPH_ENDPOINT = /*#__PURE__*/concatUrl('/api/v2/graph/');
export var GRAPH_ENDPOINT_AUTH = /*#__PURE__*/concatUrl(/*#__PURE__*/"".concat(BASE_PATH, "/auth/"));
export var GRAPH_ENDPOINT_PAYMENTS = /*#__PURE__*/concatUrl(/*#__PURE__*/"".concat(BASE_PATH, "/payments/"));
export var GRAPH_ENDPOINT_PRIVATE = /*#__PURE__*/concatUrl(/*#__PURE__*/"".concat(BASE_PATH, "/private/"));
export var GRAPH_ENDPOINT_B2B = /*#__PURE__*/concatUrl(/*#__PURE__*/"".concat(BASE_PATH, "/b2b/"));
export var GRAPH_ENDPOINT_SEARCH = /*#__PURE__*/concatUrl(/*#__PURE__*/"".concat(BASE_PATH, "/search/"));
export var GRAPH_ENDPOINT_V3 = /*#__PURE__*/concatUrl('/api/v3/graph/');
export var GRAPH_ENDPOINT_V4 = /*#__PURE__*/concatUrl('/api/graph/');
export var GRAPH_ENDPOINT_V4_AUTHENTICATION = /*#__PURE__*/concatUrl('/api/graph/authentication/');
export var GRAPH_ENDPOINT_V4_B2B = /*#__PURE__*/concatUrl('/api/graph/b2b/');
export var GRAPH_ENDPOINT_V4_STAFF = /*#__PURE__*/concatUrl('/api/graph/staff/');
export var GRAPH_ENDPOINT_V5 = /*#__PURE__*/concatUrl('/api/v5/graph/');
export var GRAPH_ENDPOINT_V5_ANALYTICS = /*#__PURE__*/concatUrl('/api/v5/graph/analytics');
export var GRAPH_ENDPOINT_CENTRALIZED = /*#__PURE__*/concatUrl('/api/graph/centralized/');
export var GRAPH_ENDPOINT_TALENT_FEEDBACK = /*#__PURE__*/concatUrl('/api/graph/talent/feedback/');